/**
 * This is default flickity carousel class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
import Flickity from "flickity";
import {
  flickityReadyHandler,
  flickityChangeHandler,
  flickitySettleHandler,
} from "../utils/flickity";

export default class StatGrid {
  constructor(elem, APP) {
    this.elem = elem;
    this.carousel = this.elem.querySelector(".js-slider");
    this.slides = this.elem.querySelectorAll(".js-slide");
    this.indicator = this.elem.querySelector(".js-indicator");
    this.thumb = this.elem.querySelector(".js-thumb");
    this.thumb_width;
    this.currentID = 0;
    this.flkty;

    this.windowWidth = window.innerWidth;
  }

  resizeCarousel() {
    if (this.windowWidth != window.innerWidth) {
      this.updateIndicator();
      // this.flkty.destroy();
      // this.setupCarousel();
      // this.slideHeight = 0;
      this.windowWidth = window.innerWidth;
    }
  }

  updateIndicator() {
    const count = this.slides.length;
    const w = this.indicator.offsetWidth;

    this.thumb_width = w / count;

    this.thumb.style.width = `${this.thumb_width}px`;
    this.thumb.style.left = `${this.thumb_width * this.currentID}px`;
  }

  setupCarousel() {
    this.updateIndicator();

    this.flkty = new Flickity(this.carousel, {
      // setGallerySize: false,
      accessibility: false,
      prevNextButtons: this.slides.length > 1,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "center",
      wrapAround: true,
      groupCells: true,
      draggable: true,
      // contain: true,
      on: {
        // ready: () => {
        //   this.dots = this.elem.querySelectorAll(".flickity-page-dots button");
        //   flickityReadyHandler(this.carousel, this.dots);
        // },
        change: (index) => {
          // flickityChangeHandler(this.dots, index);
          this.currentID = index;
          this.updateIndicator();
        },
        // settle: () => {
        //   flickitySettleHandler(this.carousel.querySelectorAll(".js-slide"));
        // },
      },
    });
  }

  init() {
    this.setupCarousel();

    window.addEventListener("resize", () => {
      this.resizeCarousel();
    });
  }
}
